import { app } from "modular-openscriptjs";
import { authenticated, fireEvent, afterAuth, inform, redirect, empty } from "../helpers";
import { STRINGS, api, gc } from "../declarations";
import { Preferences } from "@capacitor/preferences";

export class Middleware {
	/**
	 * Ensures the user is authenticated
	 * @param {function} next
	 * @returns {Middleware|boolean|null|undefined}
	 */
	auth(next) {
		if (authenticated()) {
			const route = app("router");
			const user = gc.user.value;

			if (!user?.phone) {
				if (!route.is("user.edit-profile")) {
					let url = location.pathname;
					Preferences.set({ key: "redirect-url-after-auth", value: url });
					inform("Please update your phone number to continue", STRINGS.WARNING);
					route.to("user.edit-profile");
					return null;
				}
			} else {
				if (!route.is("user.verify-identity") && !route.is("user.edit-profile")) {
					const verifiedAt = window.otpVerifiedAt || 0;
					const now = Date.now();
					const isExpired = !verifiedAt || (now - verifiedAt > 24 * 60 * 60 * 1000);

					if (isExpired) {
						let url = location.pathname;
						Preferences.set({ key: "redirect-url-after-auth", value: url });

						api.post("/auth/send/otp").catch(console.error);

						inform("Please verify your identity with OTP", STRINGS.INFO);
						route.to("user.verify-identity");
						return null;
					}
				}
			}

			if(typeof next === "undefined") {
				return this;
			}
			else if(typeof next === "function") {
				return next();
			}
			else {
				return true;
			}
		}

		let url = location.pathname;
		Preferences.set({ key: "redirect-url-after-auth", value: url });

		inform("Please log in to continue", STRINGS.ERROR);
		app("router").to("user.login");
		return null;
	}

	/**
	 * Ensures the company is selected
	 * @param {function} next
	 * @returns {any}
	 */
	company(next) {
		if (window.currentCompany?.id) {
			if(typeof next === "undefined") {
				return this;
			}
			else if(typeof next === "function") {
				return next();
			}
			else {
				return true;
			}
		}
		inform("Please select a company to continue", STRINGS.INFO);
		app("router").to("company.select");
		return null;
	}
}
